<template>
  <v-row justify="start">
    <v-dialog
      v-model="d_risk"
      persistent
      max-width="400px"
      scrollable
      @click:outside="$emit('close')"
      @keydown.esc="$emit('close')"
    >
      <v-card class="rounded_max hide_overflow" flat v-if="inventory">
        <v-toolbar dense flat>
          <h3>{{ inventory.label }}</h3>
          <v-spacer></v-spacer>
          <v-btn fab x- small depressed @click="$emit('close')"
            ><v-icon small>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <v-card-text class="px-2 pb-0">
          <v-container style="height: max-content">
            <v-text-field
              :disabled="
                permissions.includes('UPCM') ||
                role == 'VENDOR' ||
                role == 'SUPERADMIN'
                  ? false
                  : true
              "
              dense
              placeholder="Type Here"
              outlined
              v-model="inventory.value"
              hide-details
              color="green"
            ></v-text-field>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed dark color="var(--g)" @click="$emit('close')"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "UpdateRiskField",
  props: ["d_risk", "inventory"],
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  methods: {
    closeAndFetch() {
      this.$emit("refetch");
      this.$emit("close");
    },
  },
};
</script>

<style>
</style>